export const saveToken = (token, refreshToken) => {
  window.localStorage.setItem('token', token);
  window.localStorage.setItem('refresh_token', refreshToken);
}

export const isAuthenticated = () => {
  return window.localStorage.token != null;
}

export const getAccessToken = () => {
  return window.localStorage.token;
}

export const getRefreshToken = () => {
  return window.localStorage.refresh_token;
}

export const clearAccessToken = () =>{
  window.localStorage.removeItem('token');
  window.localStorage.removeItem('refresh_token');
}